module.exports = __webpack_public_path__ + "media/images/emblems/Dietlikon-blazon-871c73dc6708ba51b3b220d141db308a.svg";